module.exports = __webpack_public_path__ + "static/media/DELETE.adc17b03.svg";